import { API_BASE_URL } from '@/settings';

import { post } from './api';

class ProfileService {
  public async uploadAvatar(avatar: FormData) {
    const { data } = await post({
      baseURL: API_BASE_URL,
      url: '/learner/upload',
      data: avatar
    });
    return data?.data.url;
  }
}
const profileService = new ProfileService();
export default profileService;
